module.exports = __webpack_public_path__ + "img/wrap.8bed34c7.png";